(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageDeleteController',NativeLanguageDeleteController);

    NativeLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'NativeLanguage'];

    function NativeLanguageDeleteController($uibModalInstance, entity, NativeLanguage) {
        var vm = this;
        vm.nativeLanguage = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            NativeLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
